// extracted by mini-css-extract-plugin
export default {"spinner":"spinner--vWl6X","body":"body--YY9ds","stopped":"stopped--W60IP","logo-spin":"logo-spin--PXt2B"};